// Action types
export const ACTION_TYPES = {
    SET_PROJECT_DATA: 'SET_PROJECT_DATA',
    INITIALIZE_EVENTS: 'INITIALIZE_EVENTS',
    SET_EMAIL_ITEMS: 'SET_EMAIL_ITEMS',
    SET_SENDING_STATE: 'SET_SENDING_STATE',
    SET_ERROR_SENDING: 'SET_ERROR_SENDING',
    SET_SELECTED_MODEL: 'SET_SELECTED_MODEL',
    SET_HIDE_CANCELLED_MODELS: 'SET_HIDE_CANCELLED_MODELS',
    SET_HIDE_PAST_DATES: 'SET_HIDE_PAST_DATES',
    SET_SCOPE: 'SET_SCOPE',
    SET_SELECTED_EVENTS: 'SET_SELECTED_EVENTS',
    SET_EMAIL_FORM_DATA: 'SET_EMAIL_FORM_DATA',
    SET_UI_STATE: 'SET_UI_STATE',
    UPDATE_EMAIL_ITEMS: 'UPDATE_EMAIL_ITEMS',
    UPDATE_RECIPIENT: 'UPDATE_RECIPIENT',
    UPDATE_PROJECT_DOCUMENT: 'UPDATE_PROJECT_DOCUMENT',
    UPDATE_MODEL_DOCUMENT: 'UPDATE_MODEL_DOCUMENT',
};

// Reducer
const sendProjectDrawerReducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.SET_PROJECT_DATA:
            return {
                ...state,
                currentProject: action.payload.currentProject,
                ModelID: action.payload.ModelID,
                EventID: action.payload.EventID,
                EventType: action.payload.EventType,
                selectedModel: action.payload.ModelID,
                subject: action.payload.currentProject?.Name || '',
            };

        // Single dispatch for everything the project data produces: events list,
        // scope of the export, default selection and available models
        case ACTION_TYPES.INITIALIZE_EVENTS:
            return {
                ...state,
                projectEventsList: action.payload.projectEventsList,
                availableModels: action.payload.availableModels,
                scope: action.payload.scope,
                selectedEvents: action.payload.selectedEvents,
                hidePastDates: action.payload.hidePastDates,
            };

        case ACTION_TYPES.SET_EMAIL_ITEMS:
            return {
                ...state,
                emailItems: action.payload,
            };

        case ACTION_TYPES.SET_SENDING_STATE:
            return {
                ...state,
                isSending: action.payload,
            };

        case ACTION_TYPES.SET_ERROR_SENDING:
            return {
                ...state,
                errorSending: action.payload,
            };

        case ACTION_TYPES.SET_SELECTED_MODEL:
            return {
                ...state,
                selectedModel: action.payload,
            };

        case ACTION_TYPES.SET_HIDE_CANCELLED_MODELS:
            return {
                ...state,
                hideCancelledModels: action.payload,
            };

        // The switch is a shortcut on the scope: it checks or unchecks the past dates
        case ACTION_TYPES.SET_HIDE_PAST_DATES:
            return {
                ...state,
                hidePastDates: action.payload.hidePastDates,
                scope: action.payload.scope,
            };

        case ACTION_TYPES.SET_SCOPE:
            return {
                ...state,
                scope: action.payload,
            };

        case ACTION_TYPES.SET_SELECTED_EVENTS:
            return {
                ...state,
                selectedEvents: action.payload,
            };

        case ACTION_TYPES.SET_EMAIL_FORM_DATA:
            return {
                ...state,
                ...action.payload,
            };

        case ACTION_TYPES.SET_UI_STATE:
            return {
                ...state,
                ...action.payload,
            };

        case ACTION_TYPES.UPDATE_EMAIL_ITEMS:
            return {
                ...state,
                emailItems: { ...state.emailItems, ...action.payload },
            };

        case ACTION_TYPES.UPDATE_RECIPIENT:
            const updatedRecipients = state.emailItems.Recipients.map((recipient) => {
                if (recipient.ModelData.ID === action.payload.modelID) {
                    return { ...recipient, ...action.payload.updates };
                }
                return recipient;
            });
            return {
                ...state,
                emailItems: { ...state.emailItems, Recipients: updatedRecipients },
            };

        case ACTION_TYPES.UPDATE_PROJECT_DOCUMENT:
            const updatedProjectDocuments = state.emailItems.ProjectDocuments.map((doc) => {
                if (doc.DocumentID === action.payload.documentID) {
                    return { ...doc, ...action.payload.updates };
                }
                return doc;
            });
            return {
                ...state,
                emailItems: { ...state.emailItems, ProjectDocuments: updatedProjectDocuments },
            };

        case ACTION_TYPES.UPDATE_MODEL_DOCUMENT:
            const updatedRecipientsForDoc = state.emailItems.Recipients.map((recipient) => {
                if (recipient.ModelData.ID === action.payload.modelID) {
                    const updatedAttachments = recipient.Attachments.map((attachment) => {
                        if (attachment.DocumentID === action.payload.documentID) {
                            return { ...attachment, ...action.payload.updates };
                        }
                        return attachment;
                    });
                    return { ...recipient, Attachments: updatedAttachments };
                }
                return recipient;
            });
            return {
                ...state,
                emailItems: { ...state.emailItems, Recipients: updatedRecipientsForDoc },
            };

        default:
            return state;
    }
};

export default sendProjectDrawerReducer;
